import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApplicationView, } from '../../models/ApplicationModel';
import { ApplicationService } from '../../shared/services/application.service';
import { UserDto } from '../../models/User';
import { UserService } from '../../services/user.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {AccountService} from '../../services/account.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { AlertService } from '../../shared/services/alert.service';
import * as Constants from '../../models/Constants';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../shared/services/common.service';
import {ProductType, AssignAppToUser, Assignee, NonPrimaryAssignee, FacilityType} from '../../models/CommonModels';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import {UtilsService} from '../../shared/services/utils.service';
import {DraftApplicationModel, DraftFacilityData} from '../../models/ApplicationDetail';
import {ActivatedRoute} from '@angular/router';
import { ErisLoginService } from '../../services/sso/eris-login.service';

declare var $: any;

@Component({
  selector: 'app-list-applications',
  templateUrl: './list-applications.component.html',
  styleUrls: ['./list-applications.component.css']
})
export class ListApplicationsComponent implements OnInit {

  @ViewChild('assignForm') assignForm: NgForm;
  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  applications: ApplicationView[] = [];
  draftApplications: DraftApplicationModel[] = [];


  assignedUser: UserDto = null;
  previousPrimaryInspector: UserDto = null;

  datepicker: Date;
  minDate: Date;
  bsValue: Date = new Date();
  bsConfig: Partial<BsDatepickerConfig>;

  tobeAssignedInspectors: UserDto[] = [];
  tobeAssignedUsers: UserDto[] = [];
  csoUsers: UserDto[] = [];
  selectedApplication: ApplicationView;
  modalRef: BsModalRef;
  constants: any = Constants;
  productTypes: ProductType[];
  facilityTypes: FacilityType[];
  expandedApps: number[] = [];
  otherAssignees: NonPrimaryAssignee[] = [];
  loadingDraftApplications: boolean;
  modalTitle = '';
  actionModalTitle = '';
  actionModalButtonLabel = '';
  draftToBeDiscarded: DraftApplicationModel;
  secondaryInspectionAssignees = 0;
  application: ApplicationView;
  modalApplicationStatus: string;
  //currentUserRoleCodes: String[];

  constructor(private applicationService: ApplicationService, private userService: UserService, private modalService: BsModalService,
              private accountService: AccountService, private errorHandlerService: ErrorHandlerService, private utilsService: UtilsService,
              private alertService: AlertService, private spinner: NgxSpinnerService, private route: ActivatedRoute,
              private commonService: CommonService, private erisLoginService: ErisLoginService) {
                const colorTheme = 'theme-green';
                this.minDate = new Date();
                this.minDate.setDate(this.minDate.getDate());
                this.bsConfig = Object.assign({}, {dateInputFormat: 'MMMM Do YYYY', containerClass: colorTheme });
              }

  ngOnInit() {

    this.getCsoUsersForAssignment();
    this.dtOptions = this.applicationService.getDataTableOptions(this.applications);

    this.route.params.subscribe(params => {
      const applicationCategory = params['category'];
      this.applicationService.applicationCategory = '';
      this.applicationService.applicationStatus = '';
      if (applicationCategory === 'renewal') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_RENEWAL;
      } else if (applicationCategory === 'new') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_NEW;
      } else if (applicationCategory === 'change') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_CHANGE;
      } else if (applicationCategory === 'replacement') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_REPLACEMENT;
      } else if (applicationCategory === 'returnCOC') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_RETURN_COC;
      } else if (applicationCategory === 'warehouseAddition') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE;
      } else if (applicationCategory === 'tempCOC') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_TEMP_COC;
      } else if (applicationCategory === 'deleted') {
        this.applicationService.applicationStatus = Constants.DELETED;
      } else if (applicationCategory === 'tempWarehouseAddition') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE;
      } else if (applicationCategory === 'tempChange') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE;
      } else if (applicationCategory == 'returnTempCOC') {
        this.applicationService.applicationCategory = Constants.APPLICATION_TYPE_CODE_TEMP_RETURN_COC;
      } 

      this.reloadApplications();
    });

    if (this.isUserApplicant()) {
      this.getDraftedApplications();
    }
    let that = this;
    $(document).ready(function(){
      $('.i-checks-unassigned').iCheck({ checkboxClass: 'icheckbox_square-green'});
      $('.i-checks-unassigned').on('ifToggled', event => {
        if (event.currentTarget.checked) {
          // uncheck other filter buttons
          if ($('.i-checks-approved-by-me-div > .icheckbox_square-green').hasClass('checked'))  {
            $('.i-checks-approved-by-me-div > .icheckbox_square-green').removeClass('checked');
          } 
          if ($('.i-checks-assigned-to-me-div > .icheckbox_square-green').hasClass('checked'))  {
            $('.i-checks-assigned-to-me-div > .icheckbox_square-green').removeClass('checked');
          }
          that.applicationService.approvedByMeFilter = false;
          that.applicationService.currentlyAssignedToMeFilter = false;
        }
        that.applicationService.unassignedFilter = event.currentTarget.checked;
        that.reloadApplications();
      });
      $('.i-checks-approved-by-me').iCheck({ checkboxClass: 'icheckbox_square-green'});
      $('.i-checks-approved-by-me').on('ifToggled', event => {
        if (event.currentTarget.checked) {
          // uncheck other filter buttons
          if ($('.i-checks-unassigned-div > .icheckbox_square-green').hasClass('checked'))  {
            $('.i-checks-unassigned-div > .icheckbox_square-green').removeClass('checked');
          }
          if ($('.i-checks-assigned-to-me-div > .icheckbox_square-green').hasClass('checked'))  {
            $('.i-checks-assigned-to-me-div > .icheckbox_square-green').removeClass('checked');
          }
          that.applicationService.unassignedFilter = false;
          that.applicationService.currentlyAssignedToMeFilter = false;
        }
        that.applicationService.approvedByMeFilter = event.currentTarget.checked;
        that.reloadApplications();
      });
      $('.i-checks-assigned-to-me').iCheck({ checkboxClass: 'icheckbox_square-green'});
      $('.i-checks-assigned-to-me').on('ifToggled', event => {
        if (event.currentTarget.checked) {
          // uncheck other filter buttons
          if ($('.i-checks-unassigned-div > .icheckbox_square-green').hasClass('checked'))  {
            $('.i-checks-unassigned-div > .icheckbox_square-green').removeClass('checked');
          }
          if ($('.i-checks-approved-by-me-div > .icheckbox_square-green').hasClass('checked'))  {
            $('.i-checks-approved-by-me-div > .icheckbox_square-green').removeClass('checked');
          }
          that.applicationService.approvedByMeFilter = false;
          that.applicationService.unassignedFilter = false;
        }
        that.applicationService.currentlyAssignedToMeFilter = event.currentTarget.checked;
        that.reloadApplications();
      });
    });
    this.commonService.getProductTypes().subscribe(productTypes => this.productTypes = productTypes);
  }

  getCsoUsersForAssignment(){
    if(this.isUserTeamLeader() && this.csoUsers.length == 0){
      this.getUsersByRole(Constants.CSO, this.csoUsers);
    }
  }

  timeAgoCalc(date) {
    return this.utilsService.timeAgoCalc(date);
  }

  getDraftApplicationNumber(draftApp) {
    return '0'.repeat(Math.max(5, draftApp.id.toString().length) - draftApp.id.toString().length) + draftApp.id + draftApp.applicationNumber;
  }

  getDateString(createdDate) {
    if (!createdDate) {
      return '';
    }
    let date = new Date(createdDate);
    return date.toLocaleDateString('en-US', {year : 'numeric', month: 'short', day: 'numeric'});
  }

  getUsersByRole(roleCode, users) {
    this.userService.getUsersByRole(roleCode).subscribe(
      resp => {
        for (let user of resp){
          users.push(user);
        }
        // add fullName attribute
        users.map( (user) => { user.fullName = user.firstName + ' ' + user.lastName; return user; } );
      },
      error => {
        this.alertService.error('Network error, Please reload the page');
      }
    );
  }

  applicationModeRoute(app) {
    if(app.applicationCatagoryID === 2){
      return  '/renewal/edit/' + app.id + '/true'; 
    }
    else if(app.applicationCatagoryID === 3){
      return  '/change/edit/' + app.id + '/true';
    }
    else if(app.applicationCatagoryID === 4){
      return  '/replacement/edit/' + app.id + '/true' ;
    }
    else if(app.applicationCatagoryID === 5){
      return  '/returnCOC/edit/' + app.id + '/true';
    }
    else if(app.applicationCatagoryID === 6){
      return  '/warehouseAddition/edit/' + app.id + '/true';
    }
    else if(app.applicationCatagoryID === 7){
      return '/tempCOC/edit/true/' + app.id + '/draft';
    }
    else if(app.applicationCatagoryID === 8){
      return '/warehouseAdditionTemp/edit/true/' + app.id + '/true';
    }
    else if(app.applicationCatagoryID === 9){
      return '/changeTemp/edit/true/' + app.id + '/true';
    }
    else if(app.applicationCatagoryID === 10){
      return '/returnTempCOC/edit/true/' + app.id + '/true';
    }
    else{
      return '/edit/' + app.id + '/draft';
    }
    
    /**
     * const facility = app['draftFacilityData'].facility;
     * return facility ? (facility.applicationNumber  ? '/renewal/edit/' + app.id + '/true' : '/edit/'+ app.id + '/draft' ) :
     *  '/edit/'+ app.id;
    */
  }

  expandApplicationInfo(appID: number) {

    const index = this.expandedApps.findIndex(aID => aID === appID);
    if (index !== -1) {
      return;
    }
    this.expandedApps.push(appID);
    if (!this.hasnpa(appID)) {
      this.applicationService.getNonPrimayAssignees(appID).subscribe(npas => this.insertNpas(npas));
    }
  }

  collapseApplicationInfo(appID: number) {
    const index = this.expandedApps.findIndex(aID => aID === appID);

    if (index !== -1) {
      this.expandedApps.splice(index, 1);
    }
  }

  getNonPrimaryAssignees(appID: number) {

      const npa = this.otherAssignees.find(function (oa) {
        return oa.applicationID === appID;
      });

      if (npa) {
        return npa.names;
      }
      return;
    }

  hasnpa(appID: number) {

      if (this.otherAssignees.length === 0) {
        return;
      }
      const npa = this.otherAssignees.find(oa => oa.applicationID === appID);
      return npa;
  }

  insertNpas(npa: NonPrimaryAssignee) {

    if (!npa.names) {
      return;
    }

    if (this.otherAssignees.length === 0) {
      this.otherAssignees.push(npa);
    }

    npa = this.otherAssignees.find(function (oa) {
      return oa.applicationID === npa.applicationID;
    });

    if (npa) {
      return;
    } else {
      this.otherAssignees.push(npa);
    }
  }

  isExpanded(appID: number) {
    const index = this.expandedApps.findIndex(aID => aID === appID);
    return index !== -1;
  }

  getApplicationDepartment() {
    let applicationProductTypeName  = this.productTypes.find(p => p.name.trim() === this.selectedApplication.productType.trim()).name;
    if (applicationProductTypeName === Constants.PRODUCT_TYPE_FOOD) {
      return Constants.FOOD_DEPARTMENT;
    } else if (applicationProductTypeName === Constants.PRODUCT_TYPE_TOBACCO) {
      return Constants.TOBACCO_DEPARTMENT;
    } else {
      return Constants.MED_DEPARTMENT;
    }
  }

  showAssignUserModal(applicationId, template: TemplateRef < any > ) {
    this.datepicker = null;
    this.assignedUser = null;
    this.selectedApplication = this.applications.find(a => a.id === applicationId);
    const branchOfficeId = this.selectedApplication.branchOfficeID;
    let statusCode = this.selectedApplication.applicationStatusCode;
    const appDeptCode = this.getApplicationDepartment();
    this.modalTitle = 'Assign to Customer Service Officer';
    this.tobeAssignedUsers = this.csoUsers.filter(u => (u.departments.map(
      p => p.code).indexOf(appDeptCode) !== -1 &&
      u.branchOffice?.id === branchOfficeId));

    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  assignApplicationToUser() {
    let assignees: Assignee[] = [];
    assignees.push(new Assignee(this.assignedUser.id, true));
    let assignToUserData: AssignAppToUser = new AssignAppToUser( this.selectedApplication.id, assignees, this.datepicker.toISOString());

    this.spinner.show();

    this.applicationService.assignApplicationToUser(assignToUserData).subscribe(
      resp => {
        console.log('res ', resp);
        this.spinner.hide();
        if (resp) {
          this.selectedApplication.assignedUser = this.assignedUser.fullName;
          this.selectedApplication.assignedUserID = this.assignedUser.id;
          this.selectedApplication.dueDate = assignToUserData.dueDate;
          if (this.selectedApplication.applicationStatusCode === Constants.REQUESTED_CODE) {
            this.selectedApplication.applicationStatusName = Constants.CSO_ASSIGNED_MESSAGE;
            this.selectedApplication.applicationStatusCode = Constants.CSO_ASSIGNED_CODE;
          } else if ( [Constants.PAYMENT_VERIFIED_CODE, Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE, 
            Constants.PAYMENT_CONFIRMED_CODE]
            .indexOf(this.selectedApplication.applicationStatusCode) !== -1) {
            this.selectedApplication.applicationStatusName = Constants.INSPECTOR_ASSIGNED_MESSAGE;
            this.selectedApplication.applicationStatusCode = Constants.INSPECTOR_ASSIGNED_CODE;
          }
          this.alertService.success('Application Assigned to user successfully');
        } else {
          this.alertService.error('Unable to assign application, please try again later.');
        }

        this.modalRef.hide();
      },
      error => {
        this.spinner.hide();
        let errorMsg = this.errorHandlerService.handleApiError(error);
        this.alertService.error(errorMsg + ' , please try again');
        this.modalRef.hide();
      },
      () => {
        this.datepicker = null;
        this.assignedUser = null;
      }
    );
  }

  isUserApplicant(): boolean {
    return this.applicationService.isUserApplicant( this.accountService.getUserRoleCodes());
  }

  isUserTeamLeader(): boolean {
    return (this.accountService.getUserRoleCodes().indexOf(Constants.CSO_TEAM_LEADER) !== -1 ||
    this.accountService.getUserRoleCodes().indexOf(Constants.INSPECTOR_TEAM_LEADER) !== -1);
  }

  isUserInspectionTeamLeader(): boolean {
    return this.accountService.getUserRoleCodes().indexOf(Constants.INSPECTOR_TEAM_LEADER) !== -1;
  }

  isUserCSOTeamLeader(): boolean {
    return this.accountService.getUserRoleCodes().indexOf(Constants.CSO_TEAM_LEADER) !== -1;
  }

  isUserDirector(): boolean {
    return this.accountService.getUserRoleCodes().indexOf(Constants.DIRECTOR) !== -1;
  }

  isUserCSO(): boolean {
    return this.accountService.getUserRoleCodes().indexOf(Constants.CSO) !== -1;
  }

  isUserInspector(): boolean {
    return this.accountService.getUserRoleCodes().indexOf(Constants.INSPECTOR) !== -1;
  }

  showFilter(): boolean {
    // all roles except admin, super admin or applicant
    return this.isUserTeamLeader() || this.isUserCSO() || this.isUserInspector() || this.isUserDirector();
  }

  isTeamLeaderAbleToAssign(app) {

    if(app.applicationCategoryName == Constants.APPLICATION_TYPE_NAME_RETURN_COC || 
      app.applicationCategoryName == Constants.APPLICATION_TYPE_NAME_TEMP_RETURN_COC){
      return false;
    }
    //Inspector team leader shouldn't assign FIS applications coming from void certificate
    //If the appication doesn't have assigned user it is implied that it is coming from void status
    if(app.applicationStatusCode === Constants.FI_SUBMITTED && !app.assignedUser){
      return false;
    }

    if (app.applicationCategoryName != Constants.APPLICATION_TYPE_NAME_REPLACEMENT && [Constants.REQUESTED_CODE, Constants.CSO_ASSIGNED_CODE, Constants.PAYMENT_MADE_CODE, Constants.RETURN_TO_CSO_CODE]
      .indexOf(app.applicationStatusCode) !== -1) {
      return this.isUserCSOTeamLeader();
    }

    return false;
  }

  showInspTmlRenPrscActions(app) {
    if ((app.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_CHANGE || app.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_TEMP_CHANGE) 
       && app.flowTypeName == Constants.APPLICATION_FLOW_TYPE_NAME_MINOR) {
      return false;
    } else {
      return this.accountService.isUserInspectionTeamLeader() &&
        (app.applicationStatusCode === Constants.PRESCREENED_CODE ||
          app.applicationStatusCode === Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE);
    }
  }

  showSubmitForApprovalButton(app) {
    if (!this.accountService.isUserInspectionTeamLeader()) {
      return false;
    }
    if (app.applicationStatusCode === Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE) {
      return app.facilityCategoryName === Constants.FACILITY_CAT_GREEN;
    }
    if (app.applicationStatusCode === Constants.PRESCREENED_CODE) {
      if (app.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_RENEWAL) {
        return app.facilityCategoryName === Constants.FACILITY_CAT_GREEN;
      }
      if ((app.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_CHANGE ||
          app.applicationCategoryName === Constants.APPLICATION_TYPE_NAME_TEMP_CHANGE) &&
          app.flowTypeName === Constants.APPLICATION_FLOW_TYPE_NAME_MINOR) {
        return true;
      }
    }
    return false;
  }

  reloadApplications() {
    if (this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.draw();
      });
    }
  }

  getStatusColor(status) {
    if (this.isUserApplicant() && this.isAppStatusInReviewStage(status)) {
      return Constants.COLOR_MAP[Constants.UNDER_REVIEW_CODE];
    }
    return Constants.COLOR_MAP[status];
  }

  isAppStatusInReviewStage(appStatusCode) {
    return [Constants.INSPECTOR_ASSIGNED_CODE, Constants.INSPECTED_CODE, Constants.INSPECTION_FAILED_CODE,
      Constants.SUBMIT_FOR_APPROVAL_CODE, Constants.RETURN_TO_INSPECTOR_CODE, Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE,
      Constants.SUBMIT_FOR_REJECTION_CODE, Constants.INSPECTION_REJECTED_CODE, Constants.FIR_REQUESTED, Constants.FIR_REQUESTED_AFTER_INSPECTION].indexOf(appStatusCode) !== -1;
  }

  openAlertModal(template: TemplateRef<any>, draftToBeDiscarded) {
    this.draftToBeDiscarded = draftToBeDiscarded;
    this.modalRef = this.modalService.show(template);
  }

  closeModal() {
    this.draftToBeDiscarded = null;
    this.modalRef.hide();
  }

  deleteDraft() {
    this.applicationService.deleteDraftApplication(this.draftToBeDiscarded.id).subscribe(
      res => {
          if (res) {
            this.getDraftedApplications();
            this.alertService.success('Successfully discarded drafted application.');
          }else {
            this.alertService.error('Unable to discard drafted application.');
          }
      },
      err => {
        this.alertService.error('Unable to discard drafted application.');
      },
      () => {
        this.closeModal();
      }
    );
  }

  getDraftedApplications() {
    this.loadingDraftApplications = true;
    let that = this;
    this.commonService.getFacilityTypes(true).subscribe(
      res => {
        that.facilityTypes = res;
      },
      err => {

      }, () => {
        this.commonService.getProductTypes().subscribe(
          res => {
            that.productTypes = res;
          },
          err => {

          }, () => {
            this.applicationService.getDraftApplications(this.erisLoginService.getUserId()).subscribe(
              res => {
                this.draftApplications = [];
                res.forEach(r => {
                  r.draftFacilityData = Object.assign(new DraftFacilityData, JSON.parse(r.applicationJsonData));
                  if (this.productTypes && r.draftFacilityData.facility && r.draftFacilityData.productTypeID) {
                    r.productTypeName = that.productTypes.find(p => p.id === r.draftFacilityData.productTypeID).name;
                  }

                  if (this.facilityTypes && r.draftFacilityData.facility && r.draftFacilityData.facility.facilityTypeID) {
                    r.facilityTypeName = that.facilityTypes.find(p => p.id === r.draftFacilityData.facility.facilityTypeID).name;
                  }
                  this.draftApplications.push(r);
                });
                },
              err => {
                this.alertService.error('Unable to fetch drafted applications');
              },
              () => {
                this.loadingDraftApplications = false;
              }
            );
          }
        );
    }
    );

  }

  applicationMenuButtonClicked(app) {
    this.application = app;
    this.selectedApplication = app;
  }

  showActionModal(app, applicationStatus) {
    this.application = app;
    if (applicationStatus === Constants.SUBMIT_FOR_APPROVAL_CODE) {
      this.actionModalTitle = 'Submit For Approval';
      this.actionModalButtonLabel = Constants.PASS;
    } else if (applicationStatus === Constants.RETURN_TO_CSO_CODE) {
        this.actionModalTitle = 'Return to CSO';
        this.actionModalButtonLabel = Constants.RETURN;
    }

    this.modalApplicationStatus = applicationStatus;

    $('#applicationModal').modal('show');
  }

  onStatusChanged(event) {
    if (event) {
      this.reloadApplications();
    }
  }

  ngOnDestroy(){
    this.applicationService.unassignedFilter = false;
  }
}
